const tableData = [
    {
        name: 'Lucinda Stickley',
        type: 'Info',
        description: 'Data Coordiator',
        value: 'Sirnarasa',
    }
];

export { tableData };
